import {ApiService} from './../apiService.js'
const ApiService_ = new ApiService;
const client = ApiService_.client;
const apiurl = ApiService_.API_URL;

export class FeeService{
    static test(){
        const url = apiurl+`api/test`;
        return client.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static testpay(data){
        const url = apiurl+`api/createTransaction`;
        return client.post(url, data, {
            headers:{
                'Content-Type': 'application/json'
            }
        });
    }

    static squareupPay(data){
        // const url = `https://vuldha.com/squareapis/api/payment/create`;
        const url = apiurl+`api/payment/create`;
        return client.post(url, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}